import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { AlertModalComponent } from './alert-modal.component';

@NgModule({
  imports: [CommonModule, IonicModule],
  declarations: [AlertModalComponent],
  exports: [AlertModalComponent],
})
export class AlertModalModule {}
